<template>
  <ankh-list>
    <template #btn-group>
      <el-button size="small" type="primary" @click="handleSaveSubmit">{{$t('保存更改')}}</el-button>
<!--      <el-button size="small" type="primary" @click="$refs.treeTable.handleChangeExpandState()">{{ expandState ? $t('收起') : $t('展开') }}</el-button>-->
      <el-button size="small" type="success" @click="handleShowSelectPopup">{{$t('选择元素')}}</el-button>
    </template>
    <template #form-header>
      <div class="flex mb16">
        <h4>{{$t('营养成分')}}</h4>
        <span>{{$t('（100g食物所包含营养成分）')}}</span>
      </div>
    </template>
    <template #search-form>
      <el-form-item :label="$t('营养素名称')">
        <el-input v-model="searchForm.name" :placeholder="$t('营养素名称')"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{$t('查询')}}</el-button>
        <el-button @click="resetEmpty()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <tree-table :column-list="columnList"
                  :data.sync="listData"
                  :expand.sync="expandState"
                  :height="height"
                  ref="treeTable"
                  :maxLevel="2"
                  @addRow="handleChangeAddRow"
                  @checkbox-change="selectChangeEvent"
                  @checkbox-all="handleSelectAll"
                  :show-add="false"
                  :row-template="rowTemplate">

        <template #name="{row}">
          <el-input v-model="row.name" :placeholder="$t('请输入')" />
        </template>

        <template #enName="{row}">
          <el-input v-model="row.enName" :placeholder="$t('请输入')" />
        </template>

        <template #flag="{row}">
          <el-input v-model="row.flag" :placeholder="$t('请输入')" readonly />
        </template>

        <template #display="{row}">
          <el-switch inactive-value="no" active-value="yes" v-model="row.display"
                     @change="handleChangeShow($event,row)"/>
        </template>

        <template #operate="{row}">
          <div class="fb-link-flex">
            <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
          </div>
        </template>
      </tree-table>
    </template>
    <template #other>
      <select-el-popup ref="selectElPopup" @select="handleSelectEl" />
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import AnkhList from "@/components/list/AnkhList.vue";
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {handleBuildTreeData, handleDeleteTip, handleDeleteTreeNode} from "@/utils/levelUtils";
import {resetEmpty} from "@/utils/common";
import SelectElPopup from "@/views/food/components/SelectElPopup.vue";

export default {
  name: "ElManageList",
  components: {SelectElPopup, TreeTable, AnkhList},
  data() {
    return {
      searchForm: {},
      listData: [],
      expandState: true,

      // 新增行ID
      newRowIds: [],


      // 新增row 需要的字段数据
      rowTemplate: {
        name: "",
        enName: "",
        expand: "yes",
        display: "yes",
        sub: [],
        createTimeStr: this.$moment().format("YYYY-MM-DD HH:mm:ss")
      },

      vxeTable: null,

      columnList: [
        {label: "营养素名称", prop: "name", type: "input", fixed: "left", minWidth: "400"},
        {label: "英文名", prop: "enName", minWidth: "300"},
        {label: "标识", prop: "flag", minWidth: "300"},
        {label: "移动", prop: "", type: "more", minWidth: "200"},
        {label: "默认展开", prop: "expand", type: "switch", minWidth: "100"},
        {label: "默认展示", prop: "display", minWidth: "100"},
        {label: "创建时间", prop: "createTimeStr", minWidth: "200"},
        {label: "操作", prop: "operate", minWidth: "100"},
      ],
    }
  },
  methods: {
    async handleSelectEl(data) {
      try {
        const elFlagCodes = data.map(item => item.code);
        await request(this.$api.elementSort.addByElementCode + "?refRecommend=" + this.$route.query.code, elFlagCodes, {isJson: true});
        this.$message.success(this.$t("操作成功！"));
        this.handleSearch();
      } catch (err) {
        console.error(err);
      }
      console.log('data', data);
    },

    handleShowSelectPopup() {
      this.$refs.selectElPopup.showDialog = true;
    },
    resetEmpty,

    // 切换 默认展示
    handleChangeShow(val, row) {
      const flag = val === "yes";
      this.vxeTable.setCheckboxRow(row, flag);
    },

    selectChangeEvent({checked, row}) {
      row.display = checked ? "yes" : "no";
    },

    handleSelectAll({checked}) {
      this.listData.forEach(item => {
        item.display = checked ? "yes" : "no";
      })
    },


    // 保存
    async handleSaveSubmit() {
      try {
        // 获取已勾选的数据code
        const codes = this.vxeTable.getCheckboxRecords().map(item => item.code);
        const sortList = this.handleSortList([...this.listData], codes);
        let params = this.handleBuildParams(sortList);
        await request(this.$api.elementSort.save, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      } catch (e) {
        console.log(e);
      }
    },

    // 根据勾选选中排序
    handleSortList(target, selectionCode) {
      const fn = (list) => {
        const selection = [];
        // 先循环找出当前层级存在选中的
        list.forEach((item) => {
          if (item.sub.length) {
            item.sub = fn(item.sub);
          }

          if (selectionCode.includes(item.code)) {
            selection.push(item);
          }
        })

        // 当前层级有选中的，则删除选中的，并把选中的添加到最前面
        if (selection.length) {
          selection.forEach(s => {
            list.splice(list.indexOf(s), 1);
          })
          list = [...selection, ...list];
        }
        return list;
      }
      return fn(target);
    },

    // 处理数据
    handleBuildParams(list) {
      return list.map((item, index) => {
        let sub = [];
        if (item.sub.length) {
          sub = this.handleBuildParams(item.sub);
        }
        return {
          name: item.name,
          enName: item.enName,
          flag: item.flag,
          code: item.isNewAdd ? null : item.code,
          sort: index + 1,
          expand: item.expand,
          display: item.display,
          sub,
          refRecommend: this.$route.query.code
        }
      })
    },

    // 删除
    async handleDelete(row) {
      try {
        await handleDeleteTip();
        if (!row.isNewAdd) {
          await request(this.$api.elementSort.delete, {code: row.code});
        }
        this.listData = handleDeleteTreeNode([row.code], this.listData);
        this.$message.success(this.$t('操作成功'));
      } catch (e) {
        console.error(e);
      }
    },

    // 添加行后默认选中
    handleChangeAddRow(row) {
      this.$nextTick(() => {
        this.vxeTable.setCheckboxRow(row, true);
      })
    },

    // 搜索数据
    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          onPage: false,
          refRecommend: this.$route.query.code,
        }
        let res = await request(this.$api.elementSort.list, params);
        this.listData = handleBuildTreeData(res.elementSorts, item => {
          return {
            createTimeStr: this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss"),
          }
        });
        this.$nextTick(() => {
          this.handleSelectedByDisplay();
        })
      } catch (e) {
        console.error(e);
      }
    },

    // 默认展示需要自动勾选
    handleSelectedByDisplay() {
      const fn = (list) => {
        list.forEach(item => {
          if (item.sub.length) {
            fn(item.sub);
          }
          if (item.display === "yes") {
            this.vxeTable.setCheckboxRow(item, true);
          }
        })
      }
      fn(this.listData);
    },
  },
  mounted() {
    this.vxeTable = this.$refs.treeTable.getTableRef();
    this.handleSearch();
  },
}
</script>

<style scoped>
</style>
